var OCS = OCS || {};
OCS.Parsers = OCS.Parsers || {};
OCS.Parsers.Classes = OCS.Parsers.Classes || {};
OCS.Parsers.Classes.NexradLevel3 = new Class({
    Implements: Options,
    debug: false,
    dataBuffer: {},
    dataView: {},
    PI: 3.141592653589793238,
    dataPointer: 0,
    parsed: {},
    unused: {},
    options: {},
    initialize: function (inBuffer, options) {
        this.setOptions(options);
        this.dataBuffer = inBuffer;
        this.dataView = new DataView(this.dataBuffer);
        this.DEG_PER_RAD = 180.00 / this.PI;
    },
    read_uint8: function () {
        this.dataPointer++;
        return this.dataView.getUint8(this.dataPointer - 1);
    },
    read_uint16: function () {
        this.dataPointer += 2;
        return this.dataView.getUint16(this.dataPointer - 2, false);
    },
    read_sint16: function () {
        this.dataPointer += 2;
        return this.dataView.getInt16(this.dataPointer - 2, false);
    },
    read_uint32: function () {
        this.dataPointer += 4;
        return this.dataView.getUint32(this.dataPointer - 4, false);
    },
    read_sint32: function () {
        this.dataPointer += 4;
        return this.dataView.getInt32(this.dataPointer - 4, false);
    },
    parse: function () {
        this.error = 0;
        this.errorMessage = "";
        this.debugText = "";
        try {
            this.skipLDM();

            this.parseMHB();
            if (this.read_sint16() !== -1)
            {
                this.error++;
                console.log("E1"); //Did not find divider in Product Description Block
            }
            this.parsePDB();

            this.check_compression();

            if (this.read_sint16() !== -1)
            {
                this.error++;
                console.log("E2"); //Did not find divider in Product Symbology Header
            }
            if (this.read_sint16() !== 1)
            {
                // ESRVEL has this set incorrectly
                //this.error++;
                //console.log("E3"); //Found other block where Product Symbology Block expected
            }
            this.parsePSB();

            if (this.read_sint16() !== -1)
            {
                this.error++;
                console.log("E4"); //Did not find divider in Product Symbology Layer
            }

            this.parsePSL();
            this.data_type = this.read_uint16();
            switch (this.data_type)
            {
                case 0x10:
                    this.parseRDP();
                    this.parse_10();
                    break;
                case 0xAF1F:
                    this.parseRDP();
                    this.parse_af1f();
                    break;
                default:
                    throw "Unsupported radar data type " + this.data_type;
            }

            this.parsed.km_per_bin = this.get_km_per_bin();

            this.storm_total_times();
        } catch (exception) {
            // Failed to process
        }
        
        if (this.error >= 1)
        {
            return 0;
        } else
        {
            this.parsed.payload = true;
            var parsed = this.parsed;
            this.options.data = parsed;
            this.parsed = this.options;
            this.options = {};
            
            return 1;
        }
    },
    check_compression: function () {
        if (this.unused.compressed) {
            var compressed_input = this.dataBuffer.slice(this.dataPointer, this.dataBuffer.byteLength);


            // This decompresses the data...
            var decompressed_str = ArchUtils.bz2.decode(new Uint8Array(compressed_input));

            if (decompressed_str.length !== this.unused.uncompressed_size)
                throw "bzip2 returned too few bytes";

            var decompressed = new ArrayBuffer(decompressed_str.length);
            var bv = new Uint8Array(decompressed);
            for (var i = 0, strLen = decompressed_str.length; i < strLen; i++) {
                bv[i] = decompressed_str.charCodeAt(i);
            }

            this.dataBuffer = decompressed;
            this.dataView = new DataView(this.dataBuffer);
            this.dataPointer = 0;
        }
    },
    // skip the LDM contamination if it is present
    skipLDM: function () {
        var marker = this.dataPointer;
        this.dataPointer = marker + 18;
        var p1 = this.read_uint32() | 0x000000ff;
        this.dataPointer += marker + 27;
        var p2 = this.read_uint32() | 0x000000ff;
        var sequence = 0x0d0d0aff;
        if (p1 === sequence && p2 === sequence) {
            this.dataPointer = marker + 30;
        } else {
            this.dataPointer = marker;
        }
    },
    //Message Header Block
    parseMHB: function () {
        this.unused.msg_code = this.read_uint16();
        this.unused.date_of_msg = this.read_uint16();
        this.unused.time_of_msg = this.read_uint32();
        this.unused.msg_len = this.read_uint32();
        this.parsed.src_id = this.read_uint16();
        this.unused.dst_id = this.read_uint16(); // destination id
        this.unused.num_of_blocks = this.read_uint16();
    },
    //Product Description Block
    parsePDB: function () {
        this.parsed.lat = this.read_sint32() / 1000;
        this.parsed.lon = this.read_sint32() / 1000;
        this.parsed.hght = this.read_uint16();
        this.parsed.prod_code = this.read_uint16();
        this.parsed.op_mode = this.read_uint16();
        this.unused.vol_cov_pttrn = this.read_uint16();
        this.unused.seq_num = this.read_uint16();
        this.unused.vol_scan_num = this.read_uint16();
        this.unused.vol_scan_date = this.read_uint16();
        this.unused.vol_scan_time = this.read_uint32();
        this.unused.prod_gen_date = this.read_uint16();
        this.unused.prod_gen_time = this.read_uint32();
        this.unused.p = []; // p# would be p[#-1]
        this.unused.p.push(this.read_uint16()); // p1 - hw27
        this.unused.p.push(this.read_uint16()); // p2 - hw28
        this.unused.elev_num = this.read_uint16();
        this.unused.p.push(this.read_uint16()); // p3 - hw30
        this.parsed.data_gate = []; // Was named data_gate
        this.parsed.data_gate[0] = this.read_sint16(); // hw31
        this.parsed.data_gate[1] = this.read_sint16(); // hw32
        this.parsed.data_gate[2] = this.read_sint16(); // hw33
        this.parsed.data_gate[3] = this.read_sint16(); // hw34
        this.parsed.data_gate[4] = this.read_sint16(); // hw35
        this.parsed.data_gate[5] = this.read_sint16(); // hw36
        this.parsed.data_gate[6] = this.read_sint16(); // hw37
        this.parsed.data_gate[7] = this.read_sint16(); // hw38
        this.parsed.data_gate[8] = this.read_sint16(); // hw39
        this.parsed.data_gate[9] = this.read_sint16(); // hw40
        this.parsed.data_gate[10] = this.read_sint16(); // hw41
        this.parsed.data_gate[11] = this.read_sint16(); // hw42
        this.parsed.data_gate[12] = this.read_sint16(); // hw43
        this.parsed.data_gate[13] = this.read_sint16(); // hw44
        this.parsed.data_gate[14] = this.read_sint16(); // hw45
        this.parsed.data_gate[15] = this.read_sint16(); // hw46
        this.unused.p.push(this.read_uint16()); // p4 - hw47
        this.unused.p.push(this.read_uint16()); // p5 - hw48
        this.unused.p.push(this.read_uint16()); // p6 - hw49
        this.unused.p.push(this.read_uint16()); // p7 - hw50
        this.unused.p.push(this.read_uint16()); // p8 - hw51
        this.unused.p.push(this.read_uint16()); // p9 - hw52
        this.unused.p.push(this.read_uint16()); // p10 - hw53
        this.unused.num_of_maps = this.read_uint16();
        this.unused.offset_to_symbology_block = this.read_uint32();
        this.unused.offset_to_graphic_block = this.read_uint32();
        this.unused.offset_to_tabular_block = this.read_uint32();

        this.parsed.cntr_lmbd = this.parsed.lon / this.DEG_PER_RAD; // center_lambda
        this.parsed.cntr_phi = this.parsed.lat / this.DEG_PER_RAD; // center_phi
        this.parsed.tilt_angle = this.unused.p[2] * 0.1;
        this.parsed.scl_fctr_clc = Math.cos(this.parsed.tilt_angle / this.DEG_PER_RAD); // scale_factor_calc

        this.parse_compression_flags();
    },
    parse_compression_flags: function () {
        this.unused.compressed = (this.unused.p[7] === 1);
        if (this.unused.compressed) {
            this.unused.uncompressed_size = (this.unused.p[8] << 16) + this.unused.p[9];
        }
    },
    //Product Symbology Block
    parsePSB: function () {
        this.unused.length_of_block = this.read_uint32();
        this.unused.num_of_lyrs = this.read_uint16(); // number of layers
    },
    //Product Symbology Layer
    parsePSL: function () {
        //What to do with this?
        this.unused.symbology_length = this.read_uint32();
    },
    //Radial Data info
    parseRDP: function () {
        this.unused.i_of_frst_rng_bin = this.read_uint16(); // index of first range bin
        this.parsed.num_of_rng_bins = this.read_uint16();
        this.unused.i_cntr_of_sweep = this.read_sint16();
        this.unused.j_cntr_of_sweep = this.read_sint16();
        this.parsed.scale_fctr = this.read_uint16();
        this.parsed.num_of_rdls = this.read_uint16(); // number of radials

        this.parsed.scale_fctr *= 0.1;
    },
    //Parse 0xaf1f data file type
    parse_af1f: function () {
        this.parsed.rdl_ang_strt = []; // radial angle start
        this.parsed.rdl_ang_dlt = []; // radial angle delta
        this.parsed.bin_word = [];

        for (var radial = 0; radial < this.parsed.num_of_rdls; radial++)
        {
            var num_rles = this.read_uint16() * 2;
            if (num_rles > this.parsed.num_of_rng_bins * 2) {
                console.log("E7: " + num_rles + ' > ' + this.parsed.num_of_rng_bins * 2); // too many RLE halfwords for radial
                continue;
            }

            this.parsed.rdl_ang_strt[radial] = ((360 - (this.read_uint16() / 10)) + 90) % 360;
            this.parsed.rdl_ang_dlt[radial] = this.read_uint16() / 10;

            var bin_count = 0;
            this.parsed.bin_word[radial] = [];
            for (var x = 0; x < num_rles; x++)
            {
                var rle = this.read_uint8();
                var run = (rle & 0xf0) >> 4;
                var code = rle & 0x0f;
                for (var y = 0; y < run; y++)
                {
                    this.parsed.bin_word[radial][bin_count] = code;
                    bin_count++;
                }
            }
            while (bin_count < this.parsed.num_of_rng_bins)
            {
                this.parsed.bin_word[radial][bin_count] = 0;
                bin_count++;
            }
        }
    },
    //Parse 0x10 data file type
    parse_10: function () {
        this.parsed.rdl_ang_strt = [];
        this.parsed.rdl_ang_dlt = [];
        this.parsed.bin_word = [];
        var x, radial;
        for (radial = 0; radial < this.parsed.num_of_rdls; radial++)
        {
            // num_bytes has to be a multiple of two because they must fall on
            // halfword boundaries.  Sometimes that means num_bytes is greater than
            // the number of range bins.  read_bytes is a mechanism to account for that.
            var num_bytes = this.read_uint16();
            var read_bytes = num_bytes;
            if (num_bytes > this.parsed.num_of_rng_bins) {
                read_bytes = this.parsed.num_of_rng_bins;
            }

            this.parsed.rdl_ang_strt[radial] = ((360 - (this.read_uint16() / 10)) + 90) % 360;
            this.parsed.rdl_ang_dlt[radial] = this.read_uint16() / 10;

            this.parsed.bin_word[radial] = [];
            for (x = 0; x < read_bytes; x++) {
                this.parsed.bin_word[radial][x] = this.read_uint8();
            }
            for (x = read_bytes; x < num_bytes; x++) {
                this.read_uint8(); // possible junk to pad to a halfword
            }
        }
    },
    get_km_per_bin: function () {
        switch (this.unused.msg_code) {
            case 181:
            case 182:
                return 0.14816;

            case 22:
            case 25:
            case 28:
            case 99:
            case 153:
            case 154:
            case 155:
            case 159:
            case 161:
            case 163:
            case 165:
            case 170:
            case 172:
            case 173:
            case 174:
            case 175:
            case 176:
            case 177:
                return 0.25;

            case 23:
            case 26:
            case 29:
            case 55:
            case 199:
                return 0.5;

            case 16:
            case 19:
            case 24:
            case 27:
            case 30:
            case 32:
            case 33:
            case 56:
            case 93:
            case 94:
            case 132:
            case 133:
            case 134:
            case 135:
            case 137:
            case 144:
            case 145:
            case 146:
            case 147:
            case 150:
            case 151:
            case 158:
            case 160:
            case 162:
            case 164:
            case 194:
                return 1;

            case 34:
                return 1.851852;

            case 17:
            case 20:
            case 31:
            case 78:
            case 79:
            case 80:
            case 138:
            case 169:
            case 171:
                return 2;

            case 18:
            case 21:
                return 4;

            default:
                console.log("Ekm: " + this.message_code); // uncovered km_per_bin case
                return 1;
        }
    },

    /** Method to get a timestamp from a date and time (as encoded in Nexrad)
     *
     * @method timestamp_from_datetime
     * @param jdate Modified Julian date - days since 1 January 1970, where 1 = 01jan1970
     * @param time Minutes past midnight
     */
    timestamp_from_datetime: function (jdate, time) {
        return (jdate - 1) * 86400000 + time * 60000;
    },
    storm_total_times: function () {
        var beg_date, end_date;
        switch (this.parsed.prod_code)
        {
            case 138:
            case 171:
            case 172:
            case 175:
                beg_date = this.timestamp_from_datetime(this.unused.p[0], this.unused.p[1]);
                end_date = this.timestamp_from_datetime(this.unused.p[4], this.unused.p[5]);
                break;
            case 80:
            case 146:
            case 147:
                beg_date = this.timestamp_from_datetime(this.unused.p[4], this.unused.p[5]);
                end_date = this.timestamp_from_datetime(this.unused.p[6], this.unused.p[7]);
                break;
        }
        if (beg_date && end_date) {
            this.parsed.strm_tot_times = {"begin": beg_date, "end": end_date};
        }
    }
}); // OCS.Parsers.NexradLevel3

